module.exports = __webpack_public_path__ + "img/nicole.adfe1f87.jpg";